import { SprinklesElement } from "sprinkles-js";
import { storageAvailable } from "../lib/storage";

export default class BannerElement extends SprinklesElement {
  static tagName = "notice-banner";
  static refs = ["trigger"];
  static events = { click: { method: "remove", ref: "trigger" } };

  afterConnected() {
    if (this.#canUseStorage && sessionStorage.getItem(this.#storageKey)) {
      this.remove();
    }
  }

  remove() {
    if (this.#canUseStorage) sessionStorage.setItem(this.#storageKey, "true");
    super.remove();
  }

  get #storageKey() {
    return this.dataset.storageKey;
  }

  get #canUseStorage() {
    return this.#storageKey && storageAvailable("sessionStorage");
  }
}
